import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core'
import { CanadaPostService } from 'app/modules/survey/survey-viewer/services/canada-post.service'
import { SurveyViewerService } from 'app/modules/survey/survey-viewer/services/survey-viewer.service'
import { debounce } from 'lodash-es'
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent, MatLegacyAutocompleteTrigger as MatAutocompleteTrigger } from '@angular/material/legacy-autocomplete'
import { IAddressSuggestion } from 'app/interfaces/IAddressSuggestion'
import { Observable } from 'rxjs'
import { AbstractControl, UntypedFormControl } from '@angular/forms'
import { addressValidator } from 'app/form-validators/AddressValidator'
import { IQuestionComponent } from 'app/interfaces/IQuestionComponent'
import { Address } from 'app/models/questions/Address'

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddressComponent implements IQuestionComponent, OnInit {

  @ViewChild('trigger', { read: MatAutocompleteTrigger }) trigger: MatAutocompleteTrigger;

  @Input() activeLang: string
  @Input() isSmallScreen: boolean
  @Input() question: Address

  addressFormControlPlaceholder: UntypedFormControl = new UntypedFormControl('')
  questionFormControl: AbstractControl
  addressSuggestions$: Observable<IAddressSuggestion[]>
  addressValidatorErrorName = addressValidator.name

  constructor(
    public surveyViewerService: SurveyViewerService,
    public canadaPostService: CanadaPostService
  ) { }

  ngOnInit(): void {
    this.addressSuggestions$ = this.canadaPostService.addressSuggestions$
    this.questionFormControl = this.surveyViewerService.activeSurvey$.value.form.get(this.question.key).get(this.question.rowKeys.pop()).get(this.question.commentsControlName).get(this.question.addressFormControlName)
  }

  getAddressSuggestions = debounce((event: any) => {
    this.questionFormControl.markAsDirty()
    this.questionFormControl.patchValue(Address.buildEmptyAddressFormState())

    this.canadaPostService.findAddresses(event.target.value, '', this.trigger)
  }, 500)

  retrieveAddress(event: MatAutocompleteSelectedEvent) {
    const address: IAddressSuggestion = event.option.value

    if (address?.Id) {
      this.canadaPostService.retrieveAddress(address, this.questionFormControl, '', this.trigger)
    }
  }

  formatInputAddress(address: IAddressSuggestion): string {
    return address.Text + ', ' + address.Description
  }

  displayFn = (address: IAddressSuggestion) => {
    if (!address) {
      return ''
    }
    return address.Text + ', ' + address.Description
  }

  resetForm() {
    this.questionFormControl.reset(Address.buildEmptyAddressFormState())
  }

  confirmAddress() {
    this.questionFormControl.patchValue({...this.questionFormControl.value, userConfirmed: true})
  }

  triggerValidation() {
    this.addressFormControlPlaceholder.patchValue('')
    if (this.questionFormControl.hasError(this.addressValidatorErrorName)) {
      this.addressFormControlPlaceholder.setErrors(addressValidator(this.question.isOptional))
    }
  }

  resetPlaceholderForm() {
    this.addressFormControlPlaceholder.reset('')
  }
}
